// material-ui
import { Link, Stack, Typography, useMediaQuery } from "@mui/material";
import { Theme } from "@mui/material/styles";

// project import
import { useTranslation } from "utils/locales/utilityFunctions";
import { selectBrandingLinks, selectBranding } from "store/reducers/branding";
import { useSelector } from "react-redux";

const Footer = () => {
  const { translate } = useTranslation();
  const brandingLinks = useSelector(selectBrandingLinks);
  const matchDownSM = useMediaQuery((theme: Theme) => theme.breakpoints.down("sm"));

  const termsUrl = brandingLinks?.termsUrl || "https://georgemaps.io/terms-of-use-and-conditions";
  const privacyPolicyUrl =
    brandingLinks?.privacyUrl || "https://georgemaps.io/cookie-and-privacy-policy";

  const aboutUsUrl = brandingLinks?.aboutUrl || "https://georgemaps.io/our-world/about-us"; 

  return (
    <Stack
      direction={matchDownSM ? "column" : "row"}
      justifyContent={matchDownSM ? "center" : "space-between"}
      sx={{ p: "12px 6px 0px", mt: "auto" }}
      textAlign={matchDownSM ? "center" : "inherit"}
      spacing={1}
    >
      <Typography variant="caption">&copy; {translate("all-rights-reserved")}</Typography>

      <Stack spacing={1.5} direction="row" justifyContent="space-between" alignItems="center">
        <Typography
          variant="subtitle2"
          color="secondary"
          component={Link}
          href={aboutUsUrl}
          target="_blank"
          underline="hover"
        >
          {translate("about-us")}
        </Typography>

        <Typography
          variant="subtitle2"
          color="secondary"
          component={Link}
          href={privacyPolicyUrl}
          target="_blank"
          underline="hover"
        >
          {translate("cookies-and-privacy")}
        </Typography>

        <Typography
          variant="subtitle2"
          color="secondary"
          component={Link}
          href={termsUrl}
          target="_blank"
          underline="hover"
        >
          {translate("terms")}
        </Typography>
      </Stack>
    </Stack>
  );
};

export default Footer;
